import get from "lodash/get";

export const getTabToShow = () => get(window, "settings.features.tabsLimit", 4);

export const addCssDynamically = () => {
  return get(window, "settings.features.enablePWA")
    ? (document.querySelector("style").textContent +=
        "@media screen and (max-width:767px) { .modules { margin-bottom: 50px; } #fc_frame, #fc_frame.fc-widget-normal { bottom: 60px !important; }")
    : "";
};

export const getPrimaryColor = () => get(window, "settings.brand.cta.primary--hover.border.color", "#ffffff");

export const getPrimaryNavigation = () => get(window, "settings.navigation.primary", []);
